import { ReactNode } from "react";

interface IDataTableNoData {
    children?: ReactNode;
}

const DataTableNoData = ({children}: IDataTableNoData) => {
    return <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: '2rem',
        paddingBottom: '2rem',
    }}>
        {children ?? "Inga resultat"}
    </div>
};

export default DataTableNoData;